<template>
    <div
        :id="item.id"
        class="tab-pane fade show active"
        role="tabpanel"
        :aria-labelledby="`${item.id}-tab`"
    >
        <section class="finfo-panel">
            <FormTabHeader icon="fal fa-poll-h" :title="item.name" />
            <div class="finfo-body">
                <!-- Stats -->
                <h3 class="fi-section-title">Statistiques</h3>
        <div class="fi-stats">
            <div class="fi-stat-card">
                <div class="fi-stat-icon" style="background: rgba(59, 130, 246, 0.1);">
                    <i class="fal fa-layer-group" style="color: #3b82f6;"></i>
                </div>
                <div class="fi-stat-info">
                    <span class="fi-stat-value">{{ form.steps_count }}</span>
                    <span class="fi-stat-label">Étapes</span>
                </div>
            </div>
            <div class="fi-stat-card">
                <div class="fi-stat-icon" style="background: rgba(16, 185, 129, 0.1);">
                    <i class="fal fa-list" style="color: #10b981;"></i>
                </div>
                <div class="fi-stat-info">
                    <span class="fi-stat-value">{{ form.attributes_count }}</span>
                    <span class="fi-stat-label">Champs</span>
                </div>
            </div>
            <div class="fi-stat-card">
                <div class="fi-stat-icon" style="background: rgba(245, 158, 11, 0.1);">
                    <i class="fal fa-ticket" style="color: #f59e0b;"></i>
                </div>
                <div class="fi-stat-info">
                    <span class="fi-stat-value">{{ form.posts_count }}</span>
                    <span class="fi-stat-label">Réponses</span>
                </div>
            </div>
        </div>

        <!-- Steps & fields -->
        <h3 class="fi-section-title">Liste des champs</h3>
        <div class="fi-steps">
            <div
                v-for="(step, stepIndex) in form.steps"
                :key="step.id"
                class="fi-step-card"
            >
                <div class="fi-step-header">
                    <span class="fi-step-number">{{ stepIndex + 1 }}</span>
                    <span class="fi-step-name">{{ step.name }}</span>
                    <span class="fi-step-count">{{ (step.attributes || []).length }} champs</span>
                </div>
                <div class="fi-step-fields">
                    <div
                        v-for="field in step.attributes"
                        :key="field.id"
                        class="fi-field"
                    >
                        <i :class="getFieldIcon(field)" class="fi-field-icon"></i>
                        <span class="fi-field-label">{{ field.label }}</span>
                        <span class="fi-field-type">{{ getFieldTypeName(field) }}</span>
                    </div>
                    <div v-if="!step.attributes || step.attributes.length === 0" class="fi-field-empty">
                        <i class="fal fa-inbox"></i>
                        Aucun champ
                    </div>
                </div>
            </div>
        </div>
            </div>
        </section>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import FormMixin from './FormMixin'
import FormTabHeader from './FormTabHeader'

const FIELD_ICONS = {
    1: 'fal fa-font', 2: 'fal fa-eye-slash', 3: 'fal fa-align-left', 4: 'fal fa-paragraph',
    5: 'fal fa-hashtag', 6: 'fal fa-map-marker-alt', 7: 'fal fa-calendar', 8: 'fal fa-calendar-alt',
    9: 'fal fa-list-alt', 10: 'fal fa-dot-circle', 11: 'fal fa-check-square', 12: 'fal fa-cloud-upload',
    13: 'fal fa-folder-tree', 14: 'fal fa-shield-alt', 15: 'fal fa-database', 16: 'fal fa-envelope',
    17: 'fal fa-star', 18: 'fal fa-microphone', 19: 'fal fa-location-arrow'
}

const FIELD_TYPE_NAMES = {
    1: 'Texte court', 2: 'Caché', 3: 'Texte long', 4: 'Texte riche',
    5: 'Nombre', 6: 'Localisation', 7: 'Date', 8: 'Date & heure',
    9: 'Liste déroulante', 10: 'Radio', 11: 'Checkbox', 12: 'Fichier',
    13: 'Catégorie', 14: 'RGPD', 15: 'Requête', 16: 'Email', 17: 'Notation',
    18: 'Prise audio', 19: 'Géolocalisation automatique'
}

const FILE_TYPE_ICONS = {
    pictures: 'fal fa-image', audio: 'fal fa-headphones',
    videos: 'fal fa-video', files: 'fal fa-file-pdf'
}

const FILE_TYPE_NAMES = {
    pictures: 'Images', audio: 'Audio', videos: 'Vidéos', files: 'Documents'
}

export default {
    name: 'FormInformation',
    mixins: [FormMixin],
    components: { FormTabHeader },
    props: ['item'],
    methods: {
        getFieldIcon(field) {
            const typeId = field.form_attribute_type_id
            if (typeId === 12 && field.config) {
                const cfg = typeof field.config === 'string' ? JSON.parse(field.config) : field.config
                if (cfg.type) return FILE_TYPE_ICONS[cfg.type] || FIELD_ICONS[12]
            }
            return FIELD_ICONS[typeId] || 'fal fa-question'
        },
        getFieldTypeName(field) {
            const typeId = field.form_attribute_type_id
            if (typeId === 12 && field.config) {
                const cfg = typeof field.config === 'string' ? JSON.parse(field.config) : field.config
                if (cfg.type) return FILE_TYPE_NAMES[cfg.type] || FIELD_TYPE_NAMES[12]
            }
            return FIELD_TYPE_NAMES[typeId] || 'Inconnu'
        }
    }
}
</script>

<style scoped>
.finfo-panel {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    overflow: hidden;
    margin-top: var(--v2-space-5);
}

.finfo-body {
    padding: var(--v2-space-5);
}

.fi-section-title {
    font-size: 0.88rem;
    font-weight: 700;
    color: var(--v2-text-1);
    margin: 24px 0 14px;
}

.finfo-body > .fi-section-title:first-child {
    margin-top: 0;
}

/* Stats */
.fi-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
}

.fi-stat-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 18px 20px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.fi-stat-card:hover {
    border-color: #bfdbfe;
    box-shadow: 0 4px 16px rgba(59, 130, 246, 0.06);
}

.fi-stat-icon {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.fi-stat-icon i {
    font-size: 1.1rem;
}

.fi-stat-info {
    display: flex;
    flex-direction: column;
}

.fi-stat-value {
    font-size: 1.5rem;
    font-weight: 700;
    color: #0f172a;
    line-height: 1;
}

.fi-stat-label {
    font-size: 0.78rem;
    color: #94a3b8;
    margin-top: 4px;
}

/* Steps */
.fi-steps {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 16px;
}

.fi-step-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    overflow: hidden;
    transition: border-color 0.2s;
}

.fi-step-card:hover {
    border-color: #bfdbfe;
}

.fi-step-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 18px;
    background: #f8fafc;
    border-bottom: 1px solid #f1f5f9;
}

.fi-step-number {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: #3b82f6;
    color: #fff;
    font-size: 0.78rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.fi-step-name {
    font-size: 0.9rem;
    font-weight: 600;
    color: #0f172a;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.fi-step-count {
    font-size: 0.72rem;
    color: #94a3b8;
    white-space: nowrap;
}

.fi-step-fields {
    padding: 8px 0;
}

.fi-field {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 18px;
    transition: background 0.15s;
}

.fi-field:hover {
    background: #f8fafc;
}

.fi-field-icon {
    color: #3b82f6;
    font-size: 0.82rem;
    width: 20px;
    text-align: center;
    flex-shrink: 0;
}

.fi-field-label {
    font-size: 0.84rem;
    color: #334155;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.fi-field-type {
    font-size: 0.7rem;
    color: #94a3b8;
    background: #f1f5f9;
    padding: 2px 8px;
    border-radius: 6px;
    white-space: nowrap;
}

.fi-field-empty {
    padding: 20px 18px;
    text-align: center;
    color: #94a3b8;
    font-size: 0.84rem;
}

.fi-field-empty i {
    margin-right: 6px;
}

@media (max-width: 640px) {
    .fi-stats {
        grid-template-columns: 1fr;
    }
}
</style>
